import { Action, createReducer, on } from '@ngrx/store';

import { fetchFlightsOptionAction } from '@flight-results/store/actions/flights-results.actions';
import {
  fetchAirValidationAction,
  fetchAirValidationBySectorAction,
  fetchPackageValidationAction,
  resetAllBookValidationErrorAction
} from '@booking/store/actions/booking.actions';
import {
  exchangeBookAction,
  exchangeBookSuccessAction,
  fetchRappiPaymentChangeErrorAction
} from '@user-history/store/actions/user-history.actions';

export const initialState = null;

const featureReducer = createReducer(
  initialState,
  on(fetchFlightsOptionAction, (state, { payload }) => payload.FlightKeys),
  on(exchangeBookAction, (state, { flightKeys }) => flightKeys),
  on(
    exchangeBookSuccessAction,
    fetchAirValidationAction,
    fetchAirValidationBySectorAction,
    resetAllBookValidationErrorAction,
    fetchRappiPaymentChangeErrorAction,
    fetchPackageValidationAction,
    () => initialState
  ),
);

export const itinerarySelectedReducer = (state: string, action: Action): string => {
  return featureReducer(state, action);
};
